import AddNewProject from "./pages/projects/AddNewProject";
import AddNewOrganization from "./pages/cooperation/AddNewOrganization";
import AddNewDelegation from "./pages/cooperation/AddNewDelegation";
import AddNewOutgoingDelegation from "./pages/cooperation/AddNewOutgoingDelegation";
import AddNewForeignStaff from "./pages/cooperation/AddNewForeignStaff";
import AddNewConference from "./pages/cooperation/AddNewConference";
import AddNewContract from "./pages/management/AddNewContract";
import AddNewCouncil from "./pages/management/AddNewCouncil";
import AddNewExpert from "./pages/management/AddNewExpert";
import AddNewScientificCV from "./pages/research/AddNewScientificCV";
import AddNewStandard from "./pages/management/AddNewStandard";
import AddNewMember from "./pages/management/AddNewMember";
import PersonnelSummary from "./pages/management/PersonnelSummary";
import ResearchPositionSummary from "./pages/management/ResearchPositionSummary";
import EquipmentManagement from "./pages/management/EquipmentManagement";
import AddNewEquipment from "./pages/management/AddNewEquipment";
import Awards from "./pages/management/Awards";
import AddNewAward from "./pages/management/AddNewAward";

export type AppRoute = {
  path: string;
  title: string;
};

export const appRoutes: AppRoute[] = [
  { path: "/", title: "Quản trị hệ thống" },

  // Sidebar primary items
  { path: "/topics", title: "Đề tài, nhiệm vụ KH&CN" },
  { path: "/cooperation", title: "Hợp tác quốc tế" },
  { path: "/documents", title: "Quản lý văn bản" },
  { path: "/articles", title: "Bài báo - Công trình khoa học" },
  { path: "/initiatives", title: "Sáng kiến kinh nghiệm" },
  { path: "/intellectual", title: "Sản phẩm sở hữu trí tuệ" },
  { path: "/contracts", title: "Hợp đồng - dịch vụ KH&CN" },
  { path: "/councils", title: "Danh sách hội đồng" },
  { path: "/experts", title: "Danh sách chuyên gia" },
  { path: "/scientific-cv", title: "Lý lịch khoa học" },
  { path: "/standards", title: "Danh sách tiêu chuẩn" },
  { path: "/council", title: "Hội đồng - Chuyên gia" },
  { path: "/organization", title: "Tổ chức - Nhân sự" },
  { path: "/statistics", title: "Thống kê - Báo cáo" },
  { path: "/awards", title: "Khen thưởng" },
  { path: "/equipment", title: "Quản lý trang thiết bị" },
  { path: "/standards", title: "Quản lý tiêu chuẩn" },
  { path: "/members", title: "Thành viên" },

  // Documents sub-routes
  { path: "/documents/incoming", title: "Văn bản đến" },
  { path: "/documents/incoming-list", title: "Danh sách văn bản đến" },
  { path: "/add-new-document", title: "Thêm văn bản" },
  { path: "/documents/incoming-unprocessed", title: "Văn bản đến chưa xử lý" },
  { path: "/documents/incoming-assigned", title: "Văn bản đến được giao" },
  { path: "/documents/incoming-reading", title: "Văn bản đến giao đọc" },
  { path: "/documents/incoming/pending", title: "Văn bản đến chưa xử lý" },
  { path: "/documents/incoming/assigned", title: "Văn bản đến được giao" },
  { path: "/documents/outgoing", title: "Văn bản đi" },
  { path: "/documents/outgoing/pending", title: "Văn bản đi chưa xử lý" },
  { path: "/documents/outgoing/assigned", title: "Văn bản đi được giao" },
  { path: "/documents/outgoing/reading", title: "Văn bản đi giao đọc" },
  { path: "/documents/regulations", title: "Văn bản pháp quy" },

  // Topics sub-routes
  { path: "/topics/approval", title: "Xét duyệt thuyết minh" },
  { path: "/topics/ongoing", title: "Đề tài đang triển khai" },
  { path: "/topics/completed", title: "Đề tài hoàn thành" },

  // Cooperation sub-routes
  { path: "/cooperation/organizations", title: "Tổ chức hợp tác" },
  { path: "/cooperation/inbound", title: "Đoàn vào" },
  { path: "/cooperation/outbound", title: "Đoàn ra" },
  { path: "/cooperation/foreign-staff", title: "Cán bộ nước ngoài" },
  { path: "/cooperation/conferences", title: "Hội nghị, hội thảo" },

  // Members sub-routes
  { path: "/members/list", title: "Danh sách thành viên" },
  { path: "/members/update", title: "Cập nhật tài khoản" },
  { path: "/members/change-password", title: "Đổi mật khẩu" },
  { path: "/members/as-faculty", title: "Xem với tư cách khoa" },
  {
    path: "/add-new-project",
    title: "Thêm dự án mới",
  },
  {
    path: "/add-new-organization",
    title: "Thêm mới tổ chức",
  },
  {
    path: "/add-new-delegation",
    title: "Thêm mới Đoàn vào",
  },
  {
    path: "/add-new-outgoing-delegation",
    title: "Thêm mới Đoàn ra",
  },
  {
    path: "/add-new-foreign-staff",
    title: "Thêm mới Cán bộ nước ngoài",
  },
  {
    path: "/add-new-conference",
    title: "Thêm mới Hội nghị, hội thảo",
  },
  {
    path: "/add-new-contract",
    title: "Thêm mới Hợp đồng",
  },
  {
    path: "/add-new-council",
    title: "Thêm mới Hội đồng",
  },
  {
    path: "/add-new-expert",
    title: "Thêm mới Chuyên gia",
  },
  {
    path: "/add-new-scientific-cv",
    title: "Thêm mới Lý lịch khoa học",
  },
  {
    path: "/add-new-standard",
    title: "Thêm mới Tiêu chuẩn",
  },
  {
    path: "/add-new-member",
    title: "Thêm mới Thành viên",
  },
  {
    path: "/personnel-summary",
    title: "Tổng hợp nhân sự theo trình độ của cán bộ",
  },
  {
    path: "/research-position-summary",
    title: "Tổng hợp nhân sự theo chức danh nghiên cứu",
  },
  {
    path: "/equipment",
    title: "Quản lý trang thiết bị",
  },
  {
    path: "/add-new-equipment",
    title: "Thêm mới Trang thiết bị",
  },
  {
    path: "/awards",
    title: "Khen thưởng",
  },
  {
    path: "/add-new-award",
    title: "Thêm mới Khen thưởng",
  },
];
